var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 190,
    height: 200,
    viewBox: "0 0 190 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "bojobad5ba"
  }, /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceGraphic",
    values: "0 0 0 0 0.036643 0 0 0 0 0.815529 0 0 0 0 0.044983 0 0 0 1.000000 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "8oim495onb",
    d: "M0 0L21 0 21 21 0 21z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-773 -468) translate(773 468)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 144,
    height: 200,
    x: 23,
    fill: "#DBEFFF",
    fillRule: "nonzero",
    rx: 17.931
  }), /*#__PURE__*/React.createElement("rect", {
    width: 117,
    height: 169,
    x: 36,
    y: 15,
    fill: "#FFF",
    fillRule: "nonzero",
    rx: 19.445
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFB450",
    fillRule: "nonzero",
    d: "M13.462 143S12.999 158.698 26 165.038c0 0-11.535 6.64-12.65 17.962 0 0-1.268-14.038-13.35-17.66.002 0 12.695-7.095 13.462-22.34zM177.46 14S177 29.698 190 36.038c0 0-11.536 6.641-12.651 17.962 0 0-1.267-14.038-13.349-17.66.001 0 12.695-7.095 13.46-22.34z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#09D00B",
    fillRule: "nonzero",
    d: "M95 67c11.04-.013 19.988-8.959 20-19.998 0-.788-.046-1.574-.137-2.356-.104-.885-.673-1.647-1.491-1.999-.818-.352-1.762-.24-2.476.292s-1.09 1.405-.986 2.29c.755 6.413-2.681 12.588-8.528 15.328-5.848 2.74-12.792 1.428-17.238-3.255-4.445-4.683-5.392-11.687-2.35-17.382 3.04-5.696 9.387-8.805 15.752-7.717.887.171 1.798-.151 2.38-.842.582-.692.745-1.644.425-2.489s-1.073-1.45-1.967-1.583c-7.443-1.278-14.97 1.746-19.462 7.817-4.492 6.07-5.18 14.154-1.781 20.897C80.54 62.746 87.448 67 95 67z"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#bojobad5ba)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(85 36)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "j0rpxhxwpc",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#8oim495onb"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#2DB674",
    d: "M15.11 7.326c-2.018 1.977-4.027 3.962-6.042 5.94-.683-.774-1.365-1.55-2.048-2.326-.203-.235-.5-.4-.816-.398-.715.003-1.206 1.004-.702 1.543.963 1.098 1.932 2.192 2.893 3.293.201.18.503.207.76.158.339-.066.566-.342.801-.57 2.148-2.088 4.298-4.174 6.446-6.264.37-.326.405-.944.063-1.303-.325-.406-.991-.452-1.355-.073M9.03.103c2.211-.314 4.523.094 6.484 1.17 2.188 1.183 3.926 3.17 4.805 5.497.884 2.313.908 4.941.07 7.271-.856 2.407-2.626 4.47-4.872 5.684-2.108 1.158-4.62 1.542-6.981 1.091-2.413-.45-4.642-1.788-6.184-3.694C.818 15.25-.03 12.832 0 10.412c.008-2.47.936-4.92 2.558-6.782C4.198 1.726 6.54.443 9.03.103",
    mask: "url(#j0rpxhxwpc)"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#09D00B",
    fillRule: "nonzero",
    d: "M105.905 37.213c.85.957 2.315 1.055 3.286.22.97-.835 1.084-2.29.253-3.264-.472-.543-.976-1.059-1.509-1.545-.615-.57-1.49-.767-2.291-.518-.803.248-1.41.905-1.59 1.721-.18.816.094 1.665.717 2.225.4.365.779.753 1.134 1.161z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D7E9F9",
    fillRule: "nonzero",
    d: "M57.494 83.998h74.981c.898.012 1.733-.462 2.186-1.24.452-.778.452-1.74 0-2.518-.453-.778-1.288-1.251-2.186-1.24H57.494C56.116 79 55 80.12 55 81.5s1.116 2.5 2.494 2.5v-.002zM114.501 101c1.38 0 2.499-1.12 2.499-2.5s-1.119-2.5-2.499-2.5H75.5C74.119 96 73 97.12 73 98.5s1.119 2.5 2.499 2.5H114.5zM124 115.5c0-1.381-1.114-2.5-2.488-2.5H66.489c-1.375 0-2.489 1.12-2.489 2.5s1.114 2.5 2.489 2.5h55.023c.66 0 1.293-.264 1.76-.733.466-.469.728-1.105.728-1.768zM72.517 130c-1.39 0-2.517 1.12-2.517 2.5s1.127 2.5 2.517 2.5h43.966c1.39 0 2.517-1.12 2.517-2.5s-1.127-2.5-2.517-2.5H72.517z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#097AD0",
    fillRule: "nonzero",
    d: "M134.544 160h-21.088c-1.356 0-2.456 1.12-2.456 2.5s1.1 2.5 2.456 2.5h21.088c1.356 0 2.456-1.12 2.456-2.5s-1.1-2.5-2.456-2.5zM75.508 160H52.492c-.886-.011-1.71.463-2.157 1.24-.447.779-.447 1.741 0 2.52.447.777 1.27 1.251 2.157 1.24h23.016c.886.011 1.71-.463 2.157-1.24.447-.779.447-1.741 0-2.52-.447-.777-1.27-1.251-2.157-1.24zM95.888 160.417c-.138-.09-.282-.167-.432-.232-.151-.062-.308-.108-.469-.137-.818-.162-1.664.093-2.256.681-.116.118-.22.245-.312.382-.089.136-.164.28-.225.431-.064.151-.112.308-.144.47-.032.16-.05.323-.05.487.001.329.067.654.194.957.062.15.137.294.225.431.094.135.198.263.312.382.472.465 1.107.727 1.769.731.164-.001.327-.018.487-.05.161-.032.318-.08.47-.144.15-.062.295-.14.43-.23.137-.09.264-.193.382-.307.114-.12.218-.247.312-.382.087-.137.163-.281.225-.431.392-.934.18-2.012-.537-2.727-.117-.116-.245-.22-.381-.312z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccess);
export default __webpack_public_path__ + "static/media/success.0ef54bab8f51751ba744b08e7e848240.svg";
export { ForwardRef as ReactComponent };